import { render, staticRenderFns } from "./Departmental-hidden.vue?vue&type=template&id=7088f572"
import script from "./Departmental-hidden.vue?vue&type=script&lang=js"
export * from "./Departmental-hidden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports